export default __webpack_public_path__ + "static/media/legendary.a24f9dcd.jpg";